import React from 'react';

import styles from './publishFundModalStyles';

import Button, {
  BUTTON_TYPES,
  BUTTON_SIZES,
  BUTTON_WIDTHS
} from 'buyside/components/presentation/Button/button';
import ErrorMessage from 'buyside/components/presentation/ErrorMessage/errorMessage';
import Modal from 'buyside/components/presentation/Modal/modal';

class PublishFundModal extends React.Component {
  constructor() {
    super();
    this.state = {
      modalOpen: false,
      status: 'unsubmitted'
    };
    this.handlePublish = this.handlePublish.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  handlePublish() {
    this.setState({ status: 'submitting' });
    this.props.publishProfile().catch(() => this.setState({ status: 'error' }));
  }

  openModal() {
    this.setState({ modalOpen: true });
  }

  closeModal() {
    this.setState({ modalOpen: false });
  }

  render() {
    const { status } = this.state;

    return (
      <Modal
        isOpen={this.state.modalOpen}
        onClose={this.closeModal}
        renderOpenModalButton={() => (
          <Button
            className={styles.publishFundButton}
            onClick={this.openModal}
            size={BUTTON_SIZES.MEDIUM}
            text="Publish Fund Profile"
            type={BUTTON_TYPES.MAJOR}
            width={BUTTON_WIDTHS.FULL}
          />
        )}
        title="Submit Fund Profile for Review"
      >
        <div>
          {status === 'error' && (
            <ErrorMessage title="Uh Oh...">
              There was a problem submitting your fund profile for review. Please refresh the page.
              If the problem persists contact{' '}
              <a href="mailto:support@sumzero.com">support@sumzero.com</a>.
            </ErrorMessage>
          )}
          <p>
            You are about to submit your fund profile for review by a SumZero administrator. It will
            not be visible until it is approved.
          </p>
          <p>
            Please verify that you have selected the correct privacy settings for each section of
            your profile. Your main Fund Profile header will be publicly visible to the SumZero
            community. Your contact information will never be visible to the community. You can
            always edit your fund's information at any time (even while it's awaiting review) by
            returning to the administrator section.
          </p>
          <div className={styles.publishFundModalButtons}>
            <Button
              text={status === 'submitting' ? 'Submitting...' : 'Submit for Approval'}
              type={BUTTON_TYPES.PRIMARY}
              onClick={this.handlePublish}
              isLoading={status === 'submitting'}
            />
            <Button
              text="Go Back"
              type={BUTTON_TYPES.SECONDARY}
              onClick={this.closeModal}
              isLoading={status === 'submitting'}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

export default PublishFundModal;
